module.exports = __webpack_public_path__ + "img/progress.d53db11a.gif";